angular.module('workflow.app')
  .filter 'capitalise', () ->
    return (str) ->
      str.charAt(0).toUpperCase() + str.slice(1)